/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetMcpServerUpstreamAuthRequirementRequestBody = {
  /**
   * The MCP server id.
   */
  mcpServerId: string;
  /**
   * Ignored.
   */
  requiresUpstreamAuth: boolean;
};

/** @internal */
export type SetMcpServerUpstreamAuthRequirementRequestBody$Outbound = {
  mcp_server_id: string;
  requires_upstream_auth: boolean;
};

/** @internal */
export const SetMcpServerUpstreamAuthRequirementRequestBody$outboundSchema:
  z.ZodMiniType<
    SetMcpServerUpstreamAuthRequirementRequestBody$Outbound,
    SetMcpServerUpstreamAuthRequirementRequestBody
  > = z.pipe(
    z.object({
      mcpServerId: z.string(),
      requiresUpstreamAuth: z.boolean(),
    }),
    z.transform((v) => {
      return remap$(v, {
        mcpServerId: "mcp_server_id",
        requiresUpstreamAuth: "requires_upstream_auth",
      });
    }),
  );

export function setMcpServerUpstreamAuthRequirementRequestBodyToJSON(
  setMcpServerUpstreamAuthRequirementRequestBody:
    SetMcpServerUpstreamAuthRequirementRequestBody,
): string {
  return JSON.stringify(
    SetMcpServerUpstreamAuthRequirementRequestBody$outboundSchema.parse(
      setMcpServerUpstreamAuthRequirementRequestBody,
    ),
  );
}
